import React, { createContext, useState, useContext } from "react";
import CustomToast from "./CustomToast";

type ToastContextType = {
  showToast: (message: string,  timer: number) => void;
};

const ToastContext = createContext<ToastContextType | undefined>(undefined);

export const useToast = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error("useToast must be used within a ToastProvider");
  }
  return context;
};

export const ToastProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [toastProps, setToastProps] = useState<{
    message: string;
    // path: string;
    timer: number;
  } | null>(null);

  const showToast = (message: string,  timer: number) => {
    setToastProps({ message, timer });
  };

  const hideToast = () => {
    setToastProps(null);
  };

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      {toastProps && (
        <CustomToast
          message={toastProps.message}
          // path={toastProps.path}
          timer={toastProps.timer}
          onClose={hideToast}
        />
      )}
    </ToastContext.Provider>
  );
};
